













































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_DeliveryLocationSave } from '@/queries/global';
import { ALL_COUNTRIES } from '@/queries/Country';
import { WithUID, generateUID } from '@/utils/utils';
import { GQL_allCountries_allCountries } from '@/queries/__generated__/allCountries';
import { postCityForZip } from '@/utils/postal-code';

@Component
export default class CustomerFormDeliveryLocations extends Vue {
  @SmartQuery(ALL_COUNTRIES) private allCountries!: GQL_allCountries_allCountries[];

  @Prop({ type: Array, required: true }) private deliveryLocations!: WithUID<GQL_DeliveryLocationSave>[];
  @Prop({ required: true }) private countryCode!: string;

  @Watch('deliveryLocations', { immediate: true })
  private ensureUIDsAreSet(): void {
    this.deliveryLocations.forEach(deliveryLocation => {
      if (!deliveryLocation.$_UID) {
        deliveryLocation.$_UID = generateUID();
      }
    });
  }

  private async fillCity(deliveryLocation: WithUID<GQL_DeliveryLocationSave>): Promise<void> {
    const city = await postCityForZip(this.$apollo, deliveryLocation);

    if(city) deliveryLocation.city = city;
  }

  private addDeliveryLocation(): void {
    this.deliveryLocations.push({
      id: undefined,
      address: undefined,
      zip: undefined,
      city: undefined,
      countryCode: this.countryCode,
      _destroy: undefined,
      $_UID: generateUID(),
    } as WithUID<GQL_DeliveryLocationSave>);
  }

  public removeDeliveryLocation(deliveryLocation: WithUID<GQL_DeliveryLocationSave>) {
    if (deliveryLocation.id) {
      Vue.set(deliveryLocation, '_destroy', true);
    } else {
      this.deliveryLocations.splice(
        this.deliveryLocations.indexOf(deliveryLocation),
        1,
      );
    }
  }

  private get notDeletedDeliveryLocations() {
    return this
      .deliveryLocations
      .filter((deliveryLocation: GQL_DeliveryLocationSave) => !deliveryLocation._destroy);
  }
}
